import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from 'react-data-table-component';
import { formatoSeparadorMilesValue, formatoSeparadorMilesValueDollar } from '../../generico/utils/FormatoInput'
import DatosSocio from "../../generico/DatosSocio"
import PopupAgregarCuenta from "../transferencias/bancaria/PopupAgregarCuenta";
import { trackPromise } from "react-promise-tracker";
import Select from "react-select";
import Popup from "react-popup";
import ResumenServices from "../../../services/resumenGeneral/resumenSocioService";
import fileDownload from "js-file-download";
import MovimientoCuentaService from "../../../services/consultas/MovimientoCuentaService";
import PopupTransferenciaXpressDetalle from "./PopupTransferenciaXpressDetalle";
import PopupTransferenciaCuentaTerceroDetalle from "./PopupTransferenciaCuentaTerceroDetalle";
import PopupTransferenciaInterbancariaDetalle from "./PopupTransferenciaInterbancariaDetalle";
import PopupAgregarCuentaCabal from "../../generico/Transferencia/CuentaExterna/PopupAgregarCuentaCabal";
import PopupAgregarCuentaTercero from "../../generico/Transferencia/CuentaExterna/PopupAgregarCuentaTercero";
import ButtonLink from "../../generico/ButtonLink";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileExcel, faCheck, faSearch } from "@fortawesome/free-solid-svg-icons";

const VER_DETALLES = 98;

const descargarMovimientoCuenta = (detalleCuenta, movimientoCuenta, tipoArchivo) => {

  detalleCuenta = detalleCuenta.find((detalle, index) => index === 0);

  let data = { detalleCuenta, movimientoCuenta, tipoArchivo }

  trackPromise(
    MovimientoCuentaService.obtenerMovimientoCuenta(data)
      .then((response) => {

        if (tipoArchivo === "PDF") {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "_blank");
        } else {

          let nombreArchivo = "";
          let contentDisposition = response.headers["content-disposition"].split(";")

          for (const value of contentDisposition) {
            if (value.indexOf("filename") > -1) {
              nombreArchivo = value.replaceAll(/\"|filename=/g, "").trim();
              break;
            }
          }

          fileDownload(response.data, nombreArchivo);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
  )
}


const DetalleMovimientoCuenta = ({ listaMovimientoCuenta, detalle, columnaMovimientoCuenta, imprimirExtracto }) => {

  let cuenta = detalle.find((detalle, index) => index === 0);

  if (listaMovimientoCuenta.length === 0) {
    return (
      <div></div>
    );
  }

  return (

    <div className="row" id="movimiento-cuenta">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            {detalle.length > 0 ?
              <>


                <div className="row">
                  <div className="col-lg-8 col-md-6">
                    <h6 className="titulo-pagina">
                      CUENTA {cuenta.ahorro} -  {cuenta.tipoCuenta} -  {cuenta.moneda}
                    </h6>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <button
                      className="btn btn-cu-primary btn-consulta"
                      onClick={() => descargarMovimientoCuenta(detalle, listaMovimientoCuenta, "PDF")}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Descarga PDF
                    </button>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <button
                      className="btn btn-cu-secundary"
                      onClick={() => descargarMovimientoCuenta(detalle, listaMovimientoCuenta, "XLS")}
                    >
                      <FontAwesomeIcon icon={faFileExcel} /> Descarga Excel
                    </button>
                  </div>
                </div>


                <div className="row py-2 border-bottom">
                  <div className="col-md-4">
                    <div className="description-block border-md-right my-2" style={{ marginTop: 0 }}>
                      <h5 className="description-header">{cuenta.saldoAnterior}  {cuenta.moneda}</h5>
                      <span className="description-text">SALDO MES ANTERIOR</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="description-block border-md-right my-2" style={{ marginTop: 0 }}>
                      <h5 className="description-header">{cuenta.saldoDisponible}  {cuenta.moneda}</h5>
                      <span className="description-text">SALDO ACTUAL</span>
                    </div>
                  </div>
                  {
                    cuenta.tipoCuenta.toLowerCase().indexOf("plazo fijo") > -1 ?
                      <div className="col-md-4">
                        <div className="description-block my-2" style={{ marginTop: 0 }}>
                          <h5 className="description-header">{cuenta.interesCapitalizado}  {cuenta.moneda}</h5>
                          <span className="description-text">INTERÉS CAPITALIZADO</span>
                        </div>
                      </div>
                      :
                      <div className="col-md-4">
                        <div className="description-block my-2" style={{ marginTop: 0 }}>
                          <h5 className="description-header">{cuenta.saldoRetenido}  {cuenta.moneda}</h5>
                          <span className="description-text">DEPÓSITO A CONFIRMAR</span>
                        </div>
                      </div>
                  }
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <DataTable
                        title="Detalle de Movimientos"
                        columns={columnaMovimientoCuenta}
                        data={listaMovimientoCuenta}
                        dense={true}
                        striped={true}
                        noDataComponent="no hay registros para mostrar" />
                    </div>
                  </div>
                </div>
              </> : listaMovimientoCuenta.length > 0 ?
                <div className="row">
                  <div className="col-md-12">
                    <hr style={{ marginTop: 0 }} />
                    <div className="table-responsive">
                      <DataTable
                        title="Detalle de Movimientos"
                        columns={columnaMovimientoCuenta}
                        data={listaMovimientoCuenta}
                        dense={true}
                        striped={true}
                        noDataComponent="no hay registros para mostrar" />
                    </div>
                  </div>
                </div>
                : <div></div>
            }

          </div>
        </div>
      </div>
    </div >
  );

}
export default class MovimientoCuenta extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listaMovimientoCuenta: [],
      listaMesAnho: [],
      mesAnhoElegido: null,
      cuentaSeleccionada: null,
      cuentaRecibida: null,
      detalle: [],
      datosDetalle: [],
      tipoCuenta: null
    };
  }
  componentDidMount() {
    this.obtenerListaMesAnho();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  //###################### LISTA MES/AÑO ###########################//    

  obtenerListaMesAnho = () => {
    var month = new Date().getMonth();

    var list = [];
    var contador = 0;
    var anho = new Date().getFullYear();
    for (var i = month + 1; i > 0; i--) {
      contador = contador + 1;
      list.push({
        value: (i) + "/" + anho,
        label: (i) + "/" + anho
      });
    }
    if (contador < 12) {
      anho = anho - 1;
      month = 12;
      for (var j = contador; j < 12; j++) {
        list.push({
          value: (month) + "/" + anho,
          label: (month) + "/" + anho
        });
        month = month - 1;
      }
    }
    this.setState({ listaMesAnho: list });
    return list;
  }

  handleChangeMesAnhoSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        mesAnhoElegido: null, listaResumen: []
      });
    else {
      this.setState({
        mesAnhoElegido: selectedOption.value
      })
    }
  }

  //###################### MOVIMIENTO CUENTA ###########################// 

  getColumnMovimientoCuenta() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
        width: "110px"
      },
      {
        name: "Hora",
        selector: row => row.hora,
        width: "100px"
      },
      {
        name: "Operación",
        selector: row => row.operacion,
        width: "110px"
      },
      {
        name: "Concepto",
        selector: row => row.concepto,
        width: "300px"
      },
      {
        name: "Débito",
        selector: row => row.debito,
        right: true,
        width: "120px"
      },
      {
        name: "Crédito",
        selector: row => row.credito,
        right: true,
        width: "110px"
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
        right: true,
        width: "110px"
      },

      {
        name: "Cuenta",
        selector: row => {
          if (row.nombreTransf?.trim()) {


            if (row.tipoMovimiento === 'D') {

              return 'Destino: ' + row.nombreTransf

            } else if (row.tipoMovimiento === 'C') {

              return 'Origen: ' + row.nombreTransf

            }
          }
        },

        width: "180px"
      },

      {
        cell: (row) => (
          <div>
            {row.tipoTransferencia &&

              <ButtonLink
                key={row.operacion}
                className="btn btn-cu-primary"
                style={{ whiteSpace: "nowrap", margin: "5px 0px" }}
                idAcceso={VER_DETALLES}
                isAcceso={true}
                onClick={() => this.mostrarDetalle(row.operacion, row.tipoTransferencia, row.tipoMovimiento)}>
                <FontAwesomeIcon icon={faSearch} /> <b>Ver Detalle</b>
              </ButtonLink>

              // <button
              //   id={"showModalCuenta"}
              //   key={row.operacion}
              //   className="btn btn-xs btn-outline-success"
              //   onClick={() => this.mostrarDetalle(row.operacion, row.tipoTransferencia, row.tipoMovimiento)}
              // >
              //   <i className="fa fa-search" /> <b>Detalle</b>
              // </button>
            }
          </div>
        ),
        width: "120px",
      }]
  }
  obtenerDetalleTransferencia(idMovimiento, tipoTransferencia, tipoMovimiento) {


    trackPromise(
      MovimientoCuentaService.obtenerDetalleTransferencia(idMovimiento, tipoTransferencia, tipoMovimiento)
        .then((response) => {
          if (response.data.codigo === 0) {

            if (response.data.datos[0].intermediario === undefined) {
              let vDatos = {
                "cedulaDestino": response.data.datos[0].cedulaDestino,
                "nroDocOrigen": response.data.datos[0].cedulaTitular,
                "cuentaOrigen": response.data.datos[0].cuentaTitular,
                "fechaTrans": response.data.datos[0].fechaOperacion,
                "idMovimiento": response.data.datos[0].idMovimiento,
                "importeCredito": response.data.datos[0].importeCredito,
                "importeDebito": response.data.datos[0].importeDebito,
                "moneda": response.data.datos[0].moneda,
                "nombreOrigen": response.data.datos[0].nombreTitular,
                "operacion": response.data.datos[0].nroOperacion,
                "nombreDestino": response.data.datos[0].titularCuentaDestino,
                "cuentaDestino": response.data.datos[0].cuentaDestino,
                "concepto": response.data.datos[0].concepto,
                "tipo": this.tipoCuenta,
                "tipoMovimiento": tipoMovimiento,
                "comprobante": response.data.datos[0].comprobante
              }

              this.setState({ datosDetalle: vDatos });
              this.modalTranfsTercero.click();
            } else {
              if (response.data.datos[0].intermediario && response.data.datos[0].intermediario === "CABAL") {
                response.data.datos[0].tipo = this.tipoCuenta;

                response.data.datos[0].tipo = this.tipoCuenta;
                response.data.datos[0].tipoMovimiento = tipoMovimiento;
                this.setState({ datosDetalle: response.data.datos[0] });
                this.modalTranfsXpres.click();
              } else if (response.data.datos[0].intermediario && response.data.datos[0].intermediario === "SIPAP") {

                response.data.datos[0].tipo = this.tipoCuenta;
                response.data.datos[0].tipoMovimiento = tipoMovimiento;
                response.data.datos[0].tipoTransferencia = tipoTransferencia;
                this.setState({ datosDetalle: response.data.datos[0] });
                this.modalTranfsInterb.click();
              }

            }

          } else {


            Popup.queue(this.notifiPopup("Info", "Movimiento no esta una transferencia"));
            return;
          }

        })
        .catch(function (error) {
          console.log(error);
        })
    )
  }


  getListaMovimientoCuenta() {
    var respuesta = [];
    var datos = [];

    var cuenta = sessionStorage.getItem("AH")

    var tipo = sessionStorage.getItem("tipo")

    if (this.state.mesAnhoElegido === null) {
      this.setState({ listaMovimientoCuenta: [], detalle: [] });
      return;
    }

    var fecha = this.state.mesAnhoElegido;

    var resultado = fecha.replace("/", "");
    if (resultado.length < 6)
      resultado = "0" + resultado
    trackPromise(
      ResumenServices.detalleAH(cuenta, resultado, tipo)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigo === "0") {
            if (jsonData.resultadosAhorros !== null) {
              if (jsonData.resultadosAhorros[0].moneda === 'U$S') {
                datos.push({
                  ahorro: jsonData.resultadosAhorros[0].ahorro,
                  tipoCuenta: jsonData.resultadosAhorros[0].tipoCuenta,
                  moneda: jsonData.resultadosAhorros[0].moneda,
                  saldoAnterior: formatoSeparadorMilesValueDollar(jsonData.resultadosAhorros[0].saldoAnterior),
                  saldoDisponible: formatoSeparadorMilesValueDollar(jsonData.resultadosAhorros[0].saldoDisponible),
                  saldoRetenido: formatoSeparadorMilesValueDollar(jsonData.resultadosAhorros[0].saldoRetenido),
                  interesCapitalizado: formatoSeparadorMilesValueDollar(jsonData.resultadosAhorros[0].interesCapitalizado),
                });
              } else {
                datos.push({
                  ahorro: jsonData.resultadosAhorros[0].ahorro,
                  tipoCuenta: jsonData.resultadosAhorros[0].tipoCuenta,
                  moneda: jsonData.resultadosAhorros[0].moneda,
                  saldoAnterior: formatoSeparadorMilesValue(jsonData.resultadosAhorros[0].saldoAnterior),
                  saldoDisponible: formatoSeparadorMilesValue(jsonData.resultadosAhorros[0].saldoDisponible),
                  saldoRetenido: formatoSeparadorMilesValue(jsonData.resultadosAhorros[0].saldoRetenido),
                  interesCapitalizado: formatoSeparadorMilesValue(jsonData.resultadosAhorros[0].interesCapitalizado),
                });
              }

              this.tipoCuenta = jsonData.resultadosAhorros[0].tipoCuenta;
            }


            if (jsonData.resultadosMovimientos === null) {
              this.setState({ listaMovimientoCuenta: [], detalle: datos });
              Popup.queue(this.notifiPopup("Info", "No tiene movimientos en la cuenta"));
              return;
            }
            for (var i = 0; i < jsonData.resultadosMovimientos.length; i++) {

              var tipo = jsonData.resultadosMovimientos[i].tipoMovimiento;
              if (tipo === "D")
                respuesta.push({
                  fecha: jsonData.resultadosMovimientos[i].fechaMovimiento,
                  hora: jsonData.resultadosMovimientos[i].horaMovimiento,
                  operacion: jsonData.resultadosMovimientos[i].operacion,
                  concepto: jsonData.resultadosMovimientos[i].concepto,
                  debito: formatoSeparadorMilesValue(jsonData.resultadosMovimientos[i].importe),
                  credito: 0,
                  saldo: formatoSeparadorMilesValue(jsonData.resultadosMovimientos[i].saldoAnterior),
                  tipo: this.tipoCuenta,
                  tipoMovimiento: jsonData.resultadosMovimientos[i].tipoMovimiento,
                  tipoTransferencia: jsonData.resultadosMovimientos[i].tipoTransferencia,
                  nombreTransf: jsonData.resultadosMovimientos[i].nombreTransf


                });
              if (tipo === "C")
                if (jsonData.resultadosAhorros[0].moneda === 'U$S') {
                  respuesta.push({
                    fecha: jsonData.resultadosMovimientos[i].fechaMovimiento,
                    hora: jsonData.resultadosMovimientos[i].horaMovimiento,
                    operacion: jsonData.resultadosMovimientos[i].operacion,
                    concepto: jsonData.resultadosMovimientos[i].concepto,
                    debito: 0,
                    credito: formatoSeparadorMilesValueDollar(jsonData.resultadosMovimientos[i].importe),
                    saldo: formatoSeparadorMilesValueDollar(jsonData.resultadosMovimientos[i].saldoAnterior),
                    tipo: this.tipoCuenta,
                    tipoMovimiento: jsonData.resultadosMovimientos[i].tipoMovimiento,
                    tipoTransferencia: jsonData.resultadosMovimientos[i].tipoTransferencia,
                    nombreTransf: jsonData.resultadosMovimientos[i].nombreTransf


                  });
                } else {
                  respuesta.push({
                    fecha: jsonData.resultadosMovimientos[i].fechaMovimiento,
                    hora: jsonData.resultadosMovimientos[i].horaMovimiento,
                    operacion: jsonData.resultadosMovimientos[i].operacion,
                    concepto: jsonData.resultadosMovimientos[i].concepto,
                    debito: 0,
                    credito: formatoSeparadorMilesValue(jsonData.resultadosMovimientos[i].importe),
                    saldo: formatoSeparadorMilesValue(jsonData.resultadosMovimientos[i].saldoAnterior),
                    tipo: this.tipoCuenta,
                    tipoMovimiento: jsonData.resultadosMovimientos[i].tipoMovimiento,
                    tipoTransferencia: jsonData.resultadosMovimientos[i].tipoTransferencia
                  });
                }

            }

            this.setState({ listaMovimientoCuenta: respuesta, detalle: datos });
          }
          else {
            this.setState({ listaMovimientoCuenta: [], detalle: [] });
            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
            return;
          }
        }


        ).catch(function (error) {

          console.log(error)
        }));

    return respuesta;
  }
  addCuentaTerceroCallback = () => {
    console.log("add cuenta sin objeto");

  };


  mostrarDetalle(idMovimiento, tipoTransferencia, tipoMovimiento) {
    this.obtenerDetalleTransferencia(idMovimiento, tipoTransferencia, tipoMovimiento);

  }



  addCuentaCallback = ({ response, data }) => {

    if (response === "OK") {
      this.setState({
        ...this.state,
        cuentaDestino: parseInt(data)
      });

      this.obtenerDetalleTransferencia(data);
    }
  };
  render() {
    //   var dark=false;



    //   if(dark){

    //     var color="#1A9185";

    //   }
    //   const customStyles = {

    //     option: (base, { data, isDisabled, isFocused, isSelected }) => {

    //     return {



    //       ...base,

    //       backgroundColor: isFocused ? color : "#181818",

    //     };

    //   }

    // };
    var list = this.state.listaMesAnho;

    return (
      <>

        <div className="content-wrapper">

          <PopupTransferenciaXpressDetalle
            idModal="modalTranfsXpres"
            addCuentaCallback={this.addCuentaCallback.bind(this)}
            items={this.state.datosDetalle}

          />
          <PopupTransferenciaCuentaTerceroDetalle
            idModal="modalTransfTercero"
            addCuentaCallback={this.addCuentaCallback.bind(this)}
            items={this.state.datosDetalle}

          />
          <PopupTransferenciaInterbancariaDetalle
            idModal="modalTransfInterb"
            addCuentaCallback={this.addCuentaCallback.bind(this)}
            items={this.state.datosDetalle}

          />

          <Titulo texto="Movimiento de Cuentas" />

          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12" style={{ zIndex: 1 }}>
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio />
                    </div>
                    <div className="card-body">
                      <label className="input-label-bold">Mes/Año *</label>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group">

                            <Select
                              required="true"
                              placeholder="-- Seleccione --"
                              onChange={this.handleChangeMesAnhoSelector}
                              options={list}
                              isClearable
                              // styles={customStyles}
                              noOptionsMessage={() => "SIN DATOS"}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-cu-primary btn-esp" onClick={() => this.getListaMovimientoCuenta()}><FontAwesomeIcon icon={faCheck} /> Consultar</button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              { }

              <DetalleMovimientoCuenta
                listaMovimientoCuenta={this.state.listaMovimientoCuenta}
                detalle={this.state.detalle}
                columnaMovimientoCuenta={this.getColumnMovimientoCuenta()}
                imprimirExtracto={this.imprimirExtracto}
              />
              <a
                data-controls-modal="modal-transf-xpress"
                ref={(a) => (this.modalTranfsXpres = a)}
                data-backdrop="false"
                href="#"
                hidden
                id="modalTranfsXpres"
                data-toggle="modal"
                data-target={"#modal-transf-xpress"}
              ></a>
              <a
                data-controls-modal="modal-transf-tercero"
                ref={(a) => (this.modalTranfsTercero = a)}
                data-backdrop="false"
                href="#"
                hidden
                id="modalTransfTercero"
                data-toggle="modal"
                data-target={"#modal-transf-tercero"}
              ></a>
              <a
                data-controls-modal="modal-transf-interb"
                ref={(a) => (this.modalTranfsInterb = a)}
                data-backdrop="false"
                href="#"
                hidden
                id="modalTranfsInterb"
                data-toggle="modal"
                data-target={"#modal-transf-interb"}
              ></a>
            </div>
          </section>
        </div>
      </>
    );
  }
}
